import qs from 'querystring'
import md5 from 'js-md5'
import i18n from 'i18next'
import { Toast } from 'antd-mobile'
import CryptoJS from 'crypto-js'

export const isProd = process.env.NODE_ENV === 'production'

// 获取url参数
export function getQueryString(name) {
  var reg = new RegExp('([?&])' + name + '=([^&]*)(&|$)')
  var r = window.location.href.substr(1).match(reg)
  if (r !== null && ![null, undefined, 'undefined'].includes(r[2]))
    return unescape(r[2])
  return null
}

// 获取当前url参数json
export function getUrlParams() {
  const query = qs.parse(window.location.href.split('?')[1])
  return query
}

// 格式化url参数
export function formatSearch(se) {
  se = decodeURIComponent(se)
  se = se.replace(/^\?/, '') //从起始索引号提取字符串中指定数目的字符
  const arr = se.split('&') //把字符串分割为字符串数组
  const obj = {}
  let newarr = []

  arr.forEach((v, i) => {
    if (!v) {
      return
    }
    //数组遍历
    newarr = v.split('=')
    if (typeof obj[newarr[0]] === 'undefined') {
      obj[newarr[0]] = newarr[1]
    }
  })

  return obj
}

/**
 * 对象转url参数
 * @param {*} data
 * @param {*} isPrefix
 */
export function queryParams(data, isPrefix) {
  isPrefix = isPrefix ? isPrefix : false
  let prefix = isPrefix ? '?' : ''
  let _result = []
  for (let key in data) {
    let value = data[key]
    // 去掉为空的参数
    if (['', undefined, null].includes(value)) {
      continue
    }
    if (value.constructor === Array) {
      value.forEach(_value => {
        _result.push(
          encodeURIComponent(key) + '[]=' + encodeURIComponent(_value)
        )
      })
    } else {
      _result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
    }
  }
  return _result.length ? prefix + _result.join('&') : ''
}

// 获取url第一个path code
export function getFirstPathCode(path) {
  const index0 = getStrTimesIndex(path, '/', 0)
  const index1 = getStrTimesIndex(path, '/', 1)

  const activeKey = path.slice(index0 + 1, index1 > 0 ? index1 : path.length)

  return activeKey
}

/**
 * 获取一个字符串值在指定字符串第n次出现的位置
 */
export function getStrTimesIndex(str, cha, num) {
  let x = str.indexOf(cha)

  for (let i = 0; i < num; i++) {
    x = str.indexOf(cha, x + 1)
  }

  return x
}

// 获取设备信息
export function getGlobalState() {
  const device = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)
    ? 'MOBILE'
    : 'DESKTOP'
  const collapsed = device !== 'DESKTOP'

  return {
    device,
    collapsed
  }
}

// 获取sid
export const getSid = () => {
  return getQueryString('sid')
}

// 获取token
export const getToken = () => {
  return (
    getQueryString('token') ||
    window.sessionStorage.getItem('auth_token') ||
    window.localStorage['token']
  )
}

// 获取个人版token
export const getPersonalToken = () => {
  return (
    getQueryString('personalToken') ||
    sessionStorage.getItem('personalToken') ||
    localStorage.getItem('personalToken')
  )
}

// 获取code
export const getCode = () => {
  return getQueryString('code')
}

// 金额输入
export const amountInput = num => {
  let str = num
  let len1 = str.substr(0, 1)
  let len2 = str.substr(1, 1)
  //如果第一位是0，第二位不是点，就用数字把点替换掉
  if (str.length > 1 && +len1 === 0 && len2 !== '.') {
    str = str.substr(1, 1)
  }
  //第一位不能是.
  if (len1 === '.') {
    str = ''
  }
  //限制只能输入一个小数点
  if (str.indexOf('.') !== -1) {
    let str_ = str.substr(str.indexOf('.') + 1)
    if (str_.indexOf('.') !== -1) {
      str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
    }
  }
  //正则替换，保留数字和小数点
  str = str.replace(/[^\d^\\.]+/g, '')
  //如果需要保留小数点后两位，则用下面公式
  str = str.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
  return str
}

/**
 * 下载url
 * @param {*} url
 * @param {*} filename
 */
export const downloadUrl = (url, filename) => {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.onload = () => {
    document.body.removeChild(link)
  }
}
export function download(opts = {}) {
  const elink = document.createElement('a')
  elink.download = opts.file_name
  elink.style.display = 'none'
  elink.href = opts.url
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}

/* 导出excel */
export const exportExcel = (path, options = {}, filename) => {
  const query = { token: getToken(), ...options }
  const url = `${process.env.REACT_APP_BASE_URL}${path}?${queryParams(query)}`
  const date = new Date()
  const times = [
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  ].map(n => {
    return n < 10 ? '0' + n : n
  })

  const _filename = (filename || i18n.t('报表')) + times.join('_')
  downloadUrl(url, _filename)
}

// 跳转admin 登录
export const goAdminLogin = () => {
  window.location.href = `${process.env.REACT_APP_BASE_ADMIN_URL}/login/`
}

// 获取uid
export function uniqueId(prefix = '') {
  const id = (~~(Math.random() * (1 << 30))).toString(36)
  return prefix ? prefix + '_' + id : id
}

/** 去除文件名后缀 */
export const formatFileName = fileName => {
  return fileName && fileName.replace(/\.[^.]*?$/, '')
}

// 对象key 按ASCII排序
export function sort_ASCII(data = {}) {
  try {
    let tempArr = []
    for (let i in data) {
      if (data[i] !== null && data[i] !== undefined) {
        let key = i
        let value = data[i]
        tempArr.push(key + '=' + value)
      }
    }
    let sortArr = tempArr.sort()
    let strASCII = sortArr.join('&')
    return strASCII
  } catch (err) {
    return ''
  }
}
// 获取签名字符串
export function getSignStr(data) {
  let signJson = {
    ...data
  }
  let secret = 'kZaPi09SaLt08'
  let timestamp = new Date().getTime().toString().substring(0, 7)
  signJson.signature = undefined
  return md5(`${sort_ASCII(signJson)}&timestamp=${timestamp}&secret=${secret}`)
}
// 请求对象添加加密字段
export function signParams(data = {}) {
  let signature = getSignStr({ ...data })
  return { ...data, signature }
}
// 获取签名字符串v2 怕影响到以前的代码，所以新加一个方法
export function getSignStrV2(data) {
  let signJson = {
    ...data
  }
  let secret = 'kZaPi09SaLt08'
  // let timestamp = new Date().getTime().toString().substring(0, 7)
  signJson.signature = undefined
  return md5(`${sort_ASCII(signJson)}&secret=${secret}`)
}
// 请求对象添加加密字段
export function signParamsV2(data = {}) {
  let signature = getSignStrV2({ ...data })
  return { ...data, signature }
}

// 格式化文件大小
export const formatFileSize = sz => {
  sz = +sz
  if (!sz || isNaN(sz)) {
    return 0
  } else if (sz < 1024) {
    return sz + 'B'
  } else if (sz / 1024 < 1024) {
    return (sz / 1024).toFixed(2) + 'K'
  } else if (sz / 1024 / 1024 < 1024) {
    return (sz / 1024 / 1024).toFixed(2) + 'M'
  } else {
    return (sz / 1024 / 1024 / 1024).toFixed(2) + 'G'
  }
}

// 格式化时长 00:00:15.10
export const formatFileDuration = duration => {
  let str = ''
  duration = duration.slice(0, duration.indexOf('.'))
  let hours = duration.slice(0, 3)
  let minute = duration.slice(3, 6)
  let s = duration.slice(6, duration.length)
  if (hours === '00:' && minute === '00:') {
    if (!+duration[6]) {
      str = duration.slice(7, duration.length) + i18n.t('秒')
    } else {
      str = s + i18n.t('秒')
    }
    return str
  } else if (hours === '00:' && minute !== '00:') {
    if (!+duration[3]) {
      if (!+duration[6]) {
        str =
          duration.slice(4, 5) +
          i18n.t('分') +
          duration.slice(7, duration.length) +
          i18n.t('秒')
      } else {
        str = duration.slice(4, 5) + i18n.t('分') + s + i18n.t('秒')
      }
    } else {
      if (!+duration[6]) {
        str =
          minute +
          i18n.t('分') +
          duration.slice(7, duration.length) +
          i18n.t('秒')
      } else {
        str = minute + i18n.t('分') + s + i18n.t('秒')
      }
    }
    return str
  }
  return duration
}

/**
 * 高亮关键字
 * @param {*} str 原字符串
 * @param {*} keyword 搜索关键字
 * @returns sHtml字符串文本
 */
export const highlightByKeyword = (str, keyword, isLink = false) => {
  if (!keyword) return str
  const split = isLink ? '' : ' '
  const sRegChar = '^$()[].*+?{}|'
  const sReg =
    '(' +
    [...new Set(keyword.split(split))]
      .map(s => {
        if (sRegChar.includes(s)) return '\\' + s
        return s
      })
      .join('|') +
    ')'
  const reg = new RegExp(sReg, 'gi')
  return str.replace(reg, '<b>$1</b>')
}

// 对象参数转换字符串参数
export const formateObjToParamStr = paramObj => {
  const filter = str => {
    // 特殊字符转义
    str += '' // 隐式转换
    str = str.replace(/%/g, '%25')
    str = str.replace(/\+/g, '%2B')
    str = str.replace(/ /g, '%20')
    str = str.replace(/\//g, '%2F')
    str = str.replace(/\?/g, '%3F')
    str = str.replace(/&/g, '%26')
    str = str.replace(/=/g, '%3D')
    str = str.replace(/#/g, '%23')
    return str
  }

  const sdata = []
  for (let attr in paramObj) {
    sdata.push(`${attr}=${filter(paramObj[attr])}`)
  }
  return sdata.join('&')
}

// var browser = {
//   versions: (function () {
//     var u = navigator.userAgent,
//       app = navigator.appVersion
//     return {
//       //移动终端浏览器版本信息
//       trident: u.indexOf('Trident') > -1, //IE内核
//       presto: u.indexOf('Presto') > -1, //opera内核
//       webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
//       gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
//       mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
//       ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
//       android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
//       iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
//       iPad: u.indexOf('iPad') > -1, //是否iPad
//       webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
//     }
//   })(),
//   language: (navigator.browserLanguage || navigator.language).toLowerCase()
// }

export const isWxBrowser = () => {
  return !!window.navigator.userAgent.match(/MicroMessenger/i)
}

export const isAndroid = () => {
  const u = window.navigator.userAgent
  return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
}

export const isIPhone = () => {
  const u = window.navigator.userAgent
  return u.indexOf('iPhone') > -1
}

export const isMobile = () => {
  const u = window.navigator.userAgent
  return !!u.match(/AppleWebKit.*Mobile.*/)
}

const isFunction = fn => typeof fn === 'function'

// copy
export const copyHandler = ({ text, success, error }, modifiers) => {
  const oClipboard = document.createElement('textarea')
  oClipboard.value = text
  oClipboard.cssText =
    'height: 0; margin: 0; padding: 0; opacity: 0; position: fixed; right: 0; bottom: 0; border: none'
  document.body.appendChild(oClipboard)
  setTimeout(() => {
    oClipboard.select()
    try {
      document.execCommand('Copy')
      isFunction(success) && success(text)
      Toast.show({
        icon: 'success',
        content: i18n.t('复制成功')
      })
    } catch (e) {
      isFunction(success) && error(e)
      Toast.show({
        icon: 'fail',
        content: i18n.t('复制失败')
      })
    }
    document.body.removeChild(oClipboard)
  })
}

// 跳转移动端login
export const jumpH5Login = (appendParams = {}) => {
  const params = {
    redirectUrl: window.location.pathname,
    ...appendParams
  }
  const redirectUrl = `/saasMobile/login?${qs.stringify({
    ...params
  })}`
  let origin = ''
  if (process.env.NODE_ENV === 'development') {
    origin = process.env.REACT_APP_BASE_URL
  }
  const href = origin + redirectUrl
  window.location.href = href
}

/*
 * @description 根据key获取cookie
 * @param {String} key
 * @returns
 */
export const getCookieItem = key => {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          '(?:(?:^|.*;)\\s*' +
            encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$'
        ),
        '$1'
      )
    ) || null
  )
}

// 设置支付产品信息
export const setPaymentPack = item => {
  try {
    let paymentPack = encrypt(JSON.stringify(item))
    sessionStorage.setItem('paymentPack', paymentPack)
    return paymentPack
  } catch (error) {
    return ''
  }
}

// 获取支付产品信息
export const getPaymentPack = () => {
  try {
    const item =
      sessionStorage.getItem('paymentPack') || getQueryString('paymentPack')
    return JSON.parse(decrypt(item))
  } catch (error) {
    return {}
  }
}

// 设置支付成功或失败产品信息
export const setPayProductInfo = item => {
  try {
    let createOrderInfo = encrypt(JSON.stringify(item))
    sessionStorage.setItem('createOrderInfo', createOrderInfo)
    return createOrderInfo
  } catch (error) {
    return ''
  }
}

// 获取支付成功或失败产品信息
export const getPayProductInfo = () => {
  try {
    const item =
      sessionStorage.getItem('createOrderInfo') ||
      getQueryString('createOrderInfo')
    return JSON.parse(decrypt(item))
  } catch (error) {
    return {}
  }
}

// 设置支付成功或失败产品信息
export const setPayOrderInfo = item => {
  try {
    let socketPayInfo = encrypt(JSON.stringify(item))
    sessionStorage.setItem('socketPayInfo', socketPayInfo)
    return socketPayInfo
  } catch (error) {
    return ''
  }
}

// 获取支付成功或失败产品信息
export const getPayOrderInfo = () => {
  try {
    const item =
      sessionStorage.getItem('socketPayInfo') || getQueryString('socketPayInfo')
    return JSON.parse(decrypt(item))
  } catch (error) {
    return {}
  }
}

const key = CryptoJS.enc.Utf8.parse('T2841C3412CPAD6F') //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('CUCDTF12H41P34Y2') //十六位十六进制数作为密钥偏移量
//解密方法
export const decrypt = word => {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}
//加密方法
export const encrypt = word => {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString().toUpperCase()
}

// 是否移动端
export const bMobile = isMobile() || isIPhone() || isAndroid() || isWxBrowser()

// 设置个人token
export const setPersonalToken = personalToken => {
  localStorage.setItem('personalToken', personalToken)
}

// 设置企业token
export const setToken = token => {
  localStorage.setItem('token', token)
}

// 清除企业token
export const clearToken = () => {
  localStorage.removeItem('token')
  sessionStorage.removeItem('token')
}

// 是否个人版
export const isPersonal = () => {
  if (!getToken() && getPersonalToken()) {
    return true
  }
  return false
}
export const sleep = millisecond => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, millisecond)
  })
}
export const isEmpty = obj => {
  return JSON.stringify(obj) === '{}'
}
export const getThumbByElementValue = item => {
  return (
    item.thumb || item.element_value.replace(/(\.mp4|\.mov|\.webm)$/, '.jpg')
  )
}

// 设置sid到cookie
export const setSid = ({ sid = '' } = {}) => {
  // sid拼到cookie
  const aimSid = getQueryString('sid') || sid
  if (!!aimSid) {
    if (/^(dev|local)/.test(process.env.REACT_APP_KZ_ENV)) {
      window.document.cookie = `dev_sid=${aimSid}; path=/; domain=kuaizi.co`
    } else {
      window.document.cookie = `sid=${aimSid}; path=/; domain=kuaizi.co`
    }
  }
}

// 设置个人token到Cookie
export const setPersonalTokenCookie = () => {
  const personalToken = getQueryString('personalToken')
  if (personalToken) {
    window.document.cookie = `userToken=${personalToken}; path=/; domain=kuaizi.co`
  }
}

/**
 * 对象转FormData
 * @param {Object} json
 */
export const jsonToFormData = (params = {}) => {
  const formData = new FormData()
  Object.keys(params).forEach(key => {
    let typeArr = ['[object Object]', '[object Array]']
    if (typeArr.includes(Object.prototype.toString.call(params[key]))) {
      formData.append(key, JSON.stringify(params[key]))
    } else {
      formData.append(key, params[key])
    }
  })

  return formData
}

/**
 * 图片压缩
 * @param {string} src
 * @param {number} width
 * @param {number} height
 * @param {number} ratio [0 - 1]
 * @param {number} minPx 最小像素
 */
export function imageCompress({
  src,
  width,
  height,
  ratio = 0.3,
  minPx = 200,
  time = false,
  rescale = false
}) {
  if (!src) {
    console.error('src is not defind')
    return
  }
  if (!width) {
    console.error('width is not defind')
    return
  }
  if (!height) {
    console.error('height is not defind')
    return
  }

  if (width < minPx && height < minPx) {
    return src
  }
  const query = qs.parse(src.split('?')[1] || '')
  let newSrc = ''

  let domainName = `${process.env.REACT_APP_IMG_URL}/resize/`
  if (rescale || query.t) {
    domainName = `${process.env.REACT_APP_IMG_URL}/rescale/`
  }

  if (src.includes(`${process.env.REACT_APP_BASE_URL}/image/`)) {
    newSrc = src
      .split('?')[0]
      .replace(`${process.env.REACT_APP_BASE_URL}/image/`, domainName)
  } else {
    newSrc = src
      .split('?')[0]
      .replace(`${process.env.REACT_APP_IMG_URL}/`, domainName)
  }

  const exts = newSrc.match(/\.\w+/g)
  const ext = exts && exts[exts.length - 1]
  const search = src.split('?')[1]

  const newWidth = Math.ceil(width * ratio)
  const newHeight = Math.ceil(height * ratio)
  const dateNow = Date.now()
  const timeStr = time ? `?t=${dateNow}&${search}` : search ? `?${search}` : ''

  if (rescale || query.t) {
    return `${newSrc}_${newWidth}x${newHeight}_${
      +query.t || dateNow
    }${ext}${timeStr}`
  }

  return `${newSrc}_${newWidth}x${newHeight}${ext}${timeStr}`
}
export const filterFileByType = ({ files, accept = [] }) => {
  if (!accept.length) {
    return {
      includes: files,
      excludes: []
    }
  }
  const includes = []
  const excludes = []
  files.forEach(file => {
    const { name, type } = file
    const suffixName = `.${name.split('.').slice(-1)[0].toLowerCase()}` // 后缀名
    if ('.jfif' === suffixName) {
      excludes.push(file)
    } else if (accept.some(item => [type, suffixName].includes(item))) {
      includes.push(file)
    } else {
      excludes.push(file)
    }
  })
  return { includes, excludes }
}
export function renderSize(value, fixed = 2) {
  if (null === value || value === '') {
    return '0 Bytes'
  }
  let unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let index = 0
  let srcSize = parseFloat(value)
  index = Math.floor(Math.log(srcSize) / Math.log(1024))
  let size = srcSize / Math.pow(1024, index)
  size = size.toFixed(fixed) //保留的小数位数
  return size + unitArr[index]
}

export const formatSize = sz => {
  sz = +sz
  if (!sz || isNaN(sz)) {
    return 0
  } else if (sz < 1024) {
    return sz + 'B'
  } else if (sz / 1024 < 1024) {
    return (sz / 1024).toFixed(2) + 'KB'
  } else if (sz / 1024 / 1024 < 1024) {
    return (sz / 1024 / 1024).toFixed(2) + 'MB'
  } else {
    return (sz / 1024 / 1024 / 1024).toFixed(2) + 'GB'
  }
}

// 获取文件后缀名
export const getExtension = url => {
  url = url.split('?')[0]
  let segments = url.split('.')
  if (segments.length > 1) {
    return segments[segments.length - 1]
  } else {
    return '' // 没有后缀名
  }
}
export default function syntaxHighlight(json) {
  if (typeof json != 'string') {
    json = JSON.stringify(json, undefined, 2)
  }
  json = json
    .replace(/&/g, '&')
    .replace(/</g, '<')
    .replace(/>/g, '>')
    .replace(/<\?php/g, '&lt;?php') // 转义PHP语法

  return json
    .replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\\-]?\d+)?)/g,
      function (match) {
        let cls = 'color:#D19A66'
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'color:#F92A0F'
          } else {
            cls = 'color:#44C91B'
          }
        } else if (/true|false/.test(match)) {
          cls = 'color:#1B73C9'
        } else if (/null/.test(match)) {
          cls = 'color:#C586C0'
        }
        return `<span style=${cls}>${match}</span>`
      }
    )
    .split('\n')
    .map((s, i) => `<div><line>${i}</line><div class='wrap'>${s}</div></div>`)
    .join('')
}
